const isNull = (param) => param === undefined || param === null

/**
 * @param {object} obj - Object to parse
 * @returns {Array<GradeGroup>}
 */
export const GradeGroupList = (obj) => obj.map((e) => new GradeGroup(e))

/** @class GradeGroup */
export class GradeGroup {
  /**
  * @param  {({ id:string|null|undefined,grade:string|null|undefined,group:string|null|undefined,levelId:string|null|undefined,levelName:string|null|undefined })} [param] - Description
  */
  constructor({
    id = null,
    grade = '',
    group = '',
    levelId = null,
    levelName = ''
  } = {}) {
    this.id = isNull(id) ? null : id;
    this.grade = isNull(grade) ? null : grade;
    this.group = isNull(group) ? null : group;
    this.levelId = isNull(levelId) ? null : levelId;
    this.levelName = isNull(levelName) ? null : levelName
    this.gradeGroupName = `${this.grade} ${this.group}`
  }

  /**
  * @param  {({ id:string|null|undefined,grade:string|null|undefined,group:string|null|undefined,levelId:string|null|undefined,levelName:string|null|undefined })} [param] - Description
  * @returns {GradeGroup} - New cloned instance of -> @class GradeGroup
  */
  copyWith({
    id = null,
    grade = '',
    group = '',
    levelId = null,
    levelName = ''
  } = {}) {
    return new GradeGroup({
      id: isNull(id) ? this.id : id,
      grade: isNull(grade) ? this.grade : grade,
      group: isNull(group) ? this.group : group,
      levelId: isNull(levelId) ? this.levelId : levelId,
      levelName: isNull(levelName) ? this.levelName : levelName
    })
  }
}